import * as React from 'react';
import { Component } from 'react';
import { ButtonCallToAction, ButtonTertiary } from 'ui';
import { StickyHeader, StickyHeaderButtonContainer } from 'app/shell/components/sticky-header/sticky-header';
import styles from './risk-matrix-sticky-header.scss';
import { RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';

export interface CodetableStickyHeaderProps {
  breadcrumbs: JSX.Element;
  translation: RiskMatrixTranslation;
  save: () => void;
  cancel: () => void;
}

export class RiskMatrixStickyHeader extends Component<CodetableStickyHeaderProps> {

  public render() {
    const {
      translation, breadcrumbs, save, cancel
    } = this.props;

    return (
      <StickyHeader className={styles.stickyHeader} rightSideContent={<>
        <StickyHeaderButtonContainer>
          <ButtonTertiary id="risk-matrix-sticky-header-cancel-button-" onClick={cancel}>
            {translation.cancel}
          </ButtonTertiary>
          <ButtonCallToAction
            id="risk-matrix-sticky-header-save-button"
            onClick={save}>
            {translation.update_risk_matrix}
          </ButtonCallToAction>
        </StickyHeaderButtonContainer>
      </>}>
        <div>
          {breadcrumbs}
        </div>
      </StickyHeader>
    );
  }
}
